import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=1b1aaacb&scoped=true"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"
import style0 from "./NavItem.vue?vue&type=style&index=0&id=1b1aaacb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1aaacb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Submenu: require('C:/app/components/Navigation/Submenu.vue').default})
